const LOCALIZED_SEGMENTS: Record<string, string> = {
  seeds: 'sementes',
  tetrazolium: 'tetrazolio',
  'sand-bed': 'canteiro-areia',
  installation: 'instalacao',
  germination: 'germinacao',
  'accelerated-aging': 'envelhecimento',
};

const INTERNAL_SEGMENTS: Record<string, string> = Object.fromEntries(
  Object.entries(LOCALIZED_SEGMENTS).map(([internal, localized]) => [localized, internal]),
);

function translatePathname(pathname: string, dictionary: Record<string, string>): string {
  return pathname
    .split('/')
    .map((segment) => dictionary[segment] ?? segment)
    .join('/');
}

export function localizeUrl(url: URL): URL {
  const localized = new URL(url);
  localized.pathname = translatePathname(url.pathname, LOCALIZED_SEGMENTS);

  return localized;
}

export function deLocalizeUrl(url: URL): URL {
  const internal = new URL(url);
  internal.pathname = translatePathname(url.pathname, INTERNAL_SEGMENTS);

  return internal;
}
